import template from './swag-cms-extensions-form-editor-settings-field-type-textarea.html.twig';

export default {
    template,
    computed: {
        rows: {
            set(newRows) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                    this.field.id,
                    'rows',
                    newRows,
                );
            },
            get() {
                return this.field?.translated?.config?.rows ?? this.field?.config?.rows ?? 5;
            },
        },
        scalable: {
            set(newScalable) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                    this.field.id,
                    'scalable',
                    newScalable,
                );
            },
            get() {
                return this.field?.translated?.config?.scalable ?? this.field?.config?.scalable ?? true;
            },
        },
        rowsOptions() {
            const rows = [];
            for (let i = 1; i < 100; i += 1) {
                rows.push(
                    {
                        value: i,
                        label: this.$tc(
                            'swag-cms-extensions.sw-cms.components.form-editor.settings-field.rowsLabel',
                            i,
                        ),
                    },
                );
            }

            return rows;
        },
    },
}
